// SVG path data and constants for the Pinpoint logo.
// Shared by ProfileAppBar (hover draw animation) and KioskLoadingAnimation (looping draw animation).

export const OUTER_LEN = 1500;
export const PIN_LEN = 600;
export const VB = 512;

export const OUTER_D = "M251.25,30.95L136,97.49c-2.94,1.7-4.75,4.83-4.75,8.22v133.08c0,3.39,1.81,6.53,4.75,8.22l115.25,66.54c2.94,1.7,6.56,1.7,9.5,0L376,247.02c2.94-1.7,4.75-4.83,4.75-8.22V105.71c0-3.39-1.81-6.53-4.75-8.22L260.75,30.95C257.81,29.26,254.19,29.26,251.25,30.95z M330.25,220.6l-69.5,40.13c-2.94,1.7-6.56,1.7-9.5,0l-69.5-40.13c-2.94-1.7-4.75-4.83-4.75-8.22v-80.25c0-3.39,1.81-6.53,4.75-8.22l69.5-40.13c2.94-1.7,6.56-1.7,9.5,0l69.5,40.13c2.94,1.7,4.75,4.83,4.75,8.22v80.25C335,215.77,333.19,218.91,330.25,220.6z";

export const PIN_D = "M240,338.76L136.62,278.8c-2.26-1.31-5.04,0.53-4.72,3.12l24.69,197.63c0.38,3.01,4.37,3.81,5.87,1.18l78.69-137.67C242.02,341.55,241.5,339.63,240,338.76z";

export const strokeStyle = {
  fill: "none",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};
